import { useState } from "react";
import { Pen } from "lucide-react";
import { useUpdateSettings } from "@/features/bootstrap";
import { cn } from "@/utils/stylesUtils";

export function DisplayNameButton() {
  const { updateSettings, isLoading } = useUpdateSettings();
  const [isOpen, setIsOpen] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const canSubmit = firstName.trim() !== "" && lastName.trim() !== "";

  async function handleSave() {
    if (!canSubmit || isLoading) {
      return;
    }
    await updateSettings({
      displayName: `${firstName.trim()} ${lastName.trim()}`,
    });

    setFirstName("");
    setLastName("");
    setIsOpen(false);
  }

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="flex flex-row items-center gap-2 text-[16px] font-normal text-[#256AA6] cursor-pointer"
      >
        <Pen size={13} className="text-[#256AA6]" />
        Change Display Name
      </button>
      <div
        className={cn(
          "fixed inset-0 sm:ml-[130px] flex items-center justify-center bg-black/30",
          isOpen
            ? "opacity-100 pointer-events-auto z-10"
            : "opacity-0 pointer-events-none",
        )}
        onClick={() => setIsOpen(false)}
      >
        <div
          className="bg-white flex flex-col items-center rounded w-[90vw] sm:w-[40vw] xl:w-[33vw] p-6 gap-4"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="text-lg font-semibold m-0">Edit Display Name</p>
          <div className="flex flex-col w-full gap-3">
            <div className="flex flex-col gap-1">
              <label htmlFor="first-name" className="text-base font-bold">
                First Name
              </label>
              <input
                id="first-name"
                type="text"
                className="w-full p-2 text-base border border-[#DDDDDD] rounded"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="last-name" className="text-base font-bold">
                Last Name
              </label>
              <input
                id="last-name"
                type="text"
                className="w-full p-2 text-base border border-[#DDDDDD] rounded"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
          <button
            disabled={!canSubmit || isLoading}
            onClick={handleSave}
            className={cn(
              "w-full py-2 px-3 text-base font-bold text-white bg-[#256AA6] rounded transition-all",
              canSubmit && !isLoading
                ? "opacity-100 cursor-pointer"
                : "opacity-40 cursor-not-allowed",
            )}
          >
            {isLoading ? "Saving..." : "SAVE DISPLAY NAME"}
          </button>
        </div>
      </div>
    </>
  );
}
